export enum PluginName {
  Attributes = 'attributes',
  Summary = 'summary',
  Description = 'description',
  SellerBadgesInfo = 'seller_badges_info',
  OtherUserItemsHeader = 'other_user_items_header',
  AdminSection = 'admin_section',
  Alert = 'alerts',
  Breadcrumbs = 'breadcrumbs',
  HighDemandSignal = 'high_demand_signal',
  Klarna = 'klarna',
}

export enum PluginType {
  Attributes = 'attributes',
  Summary = 'summary',
  Description = 'description',
  SellerBadgesInfo = 'seller_badges_info',
  ItemsBlockHeader = 'items_block_header',
  HorizontalItemsBlock = 'horizontal_items_block',
  VerticalItemsBlock = 'vertical_items_block',
  AdminSection = 'admin_section',
  Alert = 'alerts',
  Breadcrumbs = 'breadcrumbs',
  InfoBanner = 'info_banner',
  Klarna = 'klarna',
}

export enum SectionType {
  Feed = 'feed',
  Base = 'base',
}

export enum AttributeType {
  Text = 'text',
  Faq = 'faq',
  Navigational = 'navigational',
  Modal = 'modal',
  Favouritable = 'favouritable',
}

export enum ItemPageErrorReason {
  IdSlugNotString = 'item_id_slug_not_string',
  IdDoesNotExist = 'item_id_does_not_exist',
  ItemDoesNotExist = 'item_does_not_exist',
  IdSlugNotMatching = 'item_id_slug_not_matching_query',
  BannerOwner = 'banned_owner',
  DraftItem = 'draft_item',
  PermittedTransaction = 'permitted_transaction',
  CannotViewProfile = 'cannot_view_profile',
  IdDoesNotMeetRegex = 'id_does_not_meet_regex',
  InternalServerError = 'internal_server_error',
  ShippingDetailsError = 'shipping_details_error',
  EscrowFeesError = 'escrow_fees_error',
  GenericError = 'generic_error',
}

export enum ItemDisposalConditions {
  None = 0,
  ForSell = 4,
}

export enum ItemShippingDetailsDiscountType {
  All = 'all',
  Home = 'home',
  DropOff = 'drop_off',
}
